// extracted by mini-css-extract-plugin
module.exports = {"list":"InputNumberButton_list__31VRz","item":"InputNumberButton_item__2g0kq","select":"InputNumberButton_select__1B31n","hover":"InputNumberButton_hover__35XHh"};